import React, { useEffect, useState } from 'react'
import axios from '../../axios/axios'
import { apiKey, baseUrl } from '../../Constants/Constants'
import '../../cssHelper/helper.css'
import './Hero.css'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

function Hero() {
    const category = useSelector((state) => state.youtube.category)
    const [suggessions, setSuggessions] = useState([])
    const [categories, setCategories] = useState([])
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const setId = (id) => {
        navigate(`/watch?v=${id}`)
    }

    useEffect(() => {
        if (category !== '') {
            console.log(category);
            fetch(`https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=50&q=${category}&key=${apiKey}`)
                .then(result => result.json())
                .then(data => {
                    console.log(data.items);
                    setCategories(data.items)
                })
                .catch(err => console.log(err));
        } else {
            console.log("No category");
            fetch(`https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=US&key=${apiKey}`)
                .then(result => result.json())
                .then(data => {
                    setSuggessions(data.items);
                    console.log(data.items);
                })
                .catch(err => console.log(err));
        }
    }, [category]);

    return (
        <div className="Hero scroll-y scroll-hidden-x w-full grid c-repeat-3 gap-05 2 p-inline-3 pb-1">
            {
                category != '' ? (
                    categories.map((category) => (
                        <div onClick={() => setId(category.id.videoId)} className="hero-item r-15 flex w-full flex-col pointer ease-7 scroll-hidden">
                            <img src={category.snippet.thumbnails ? category.snippet.thumbnails.high.url : ''} alt="" className="thumbnail r-10 cover w-full" />
                            <div className="hero-video-details flex gap-1 mt-1 a-start">
                                <div>
                                    <img src={category.snippet.thumbnails ? category.snippet.thumbnails.high.url : ''} alt="" className="img-2 cover r-50" />
                                </div>
                                <div className="para-details flex flex-col j-center">
                                    <p className="hero-video-title font-sm bold-600" style={{ maxWidth: '90%', overflow: 'hidden', maxHeight: '3rem' }}>
                                        {category.snippet.title}
                                    </p>
                                    <p className="hero-youtuber-owner font-sm mt-1 text-2">
                                        {category.channelTitle}
                                    </p>
                                    <p className="views font-sm text-2">
                                        <span>1.7M</span>
                                        <span> views .</span>
                                        <span> 1</span>
                                        <span>year ago</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    suggessions.map((suggession) => (
                        <div onClick={() => setId(suggession.id)} className="hero-item r-15 flex w-full flex-col pointer ease-7 scroll-hidden">
                            <img src={suggession.snippet.thumbnails.standard ? suggession.snippet.thumbnails.standard.url : ''} alt="" className="thumbnail r-10 cover w-full" />
                            <div className="hero-video-details flex gap-1 mt-1 a-start">
                                <div>
                                    <img src={suggession.snippet.thumbnails.standard ? suggession.snippet.thumbnails.standard.url : ''} alt="" className="img-2 cover r-50" />
                                </div>
                                <div className="para-details flex flex-col j-center">
                                    <p className="hero-video-title font-sm bold-600" style={{ maxWidth: '90%', overflow: 'hidden', maxHeight: '3rem' }}>
                                        {suggession.snippet.title}
                                    </p>
                                    <p className="hero-youtuber-owner font-sm mt-1 text-2">
                                        {suggession.channelTitle}
                                    </p>
                                    <p className="views font-sm text-2">
                                        <span>1.7M</span>
                                        <span> views .</span>
                                        <span> 1</span>
                                        <span>year ago</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                )
            }
        </div>
    )
}

export default Hero
